import siteConfig from '@iso/config/site.config';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import internalReportActions from './actions';
import Notification from '@iso/components/Notification';

const onfetchRestaurantsList = async () =>
  await fetch(`https://orderbyte.io/api/finencial/v1/api/live-restaurants`, {
    crossDomain: true,
    method: 'GET',
    mode: 'cors',
  })
    .then((response) => response.json())
    .then((json) => {
      return json || [];
    });

function* fetchRestaurantsListStart() {
  try {
    let restaurants = yield call(onfetchRestaurantsList);

    yield put(
      internalReportActions.fetchRestaurantsListSuccess(restaurants.data)
    );
  } catch (error) {
    yield put(internalReportActions.fetchRestaurantsListFailure(error));
  }
}

export default function* internalReportSaga() {
  yield all([
    takeEvery(
      internalReportActions.FETCH_RESTAURANTS_LIST_START,
      fetchRestaurantsListStart
    ),
  ]);
}
